import { render } from "./ResourcesGoal4.vue?vue&type=template&id=265e616a"
import script from "./ResourcesGoal4.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal4.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__